import store from '../configureStore';
import { apiGet, apiPost } from './apiUtil';

export const addLinks = (resourcesIdList: string[]) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  return apiPost(`/link/add?gid=${currentUserGroup}`, {
    headers: header ? { Authorization: header } : undefined,
    body: resourcesIdList.length > 1 ? `id=${resourcesIdList.join(',')}` : `id=${resourcesIdList[0]}`,
  });
};

export const getLink = (tempId: string) => apiGet(`/link/get/${tempId}`);
